import clsx from 'clsx';
import {FC} from 'react';
import {Loader} from '@mantine/core';

import s from '../styles.module.scss';

interface DotsLoaderIconProps {
  size?: number;
  className?: string;
}

const DotsLoaderIcon: FC<DotsLoaderIconProps> = ({size = 20, className}) => (
  <Loader variant="dots" className={clsx(s['dots-icon'], className)} size={size} />
);

export default DotsLoaderIcon;
